export const PAYMENT_GATEWAY_MAPPING: Record<string, string> = {
    paypal: 'Paypal',
    stripe: 'Stripe',
    adyen: 'Adyen',
};

export const FEE_BREAKDOWN_V2_STRUCTURE = [
    { key: 'transaction_fee', name: 'Transaction Fee' },
    { key: 'conversion_fee', name: 'Conversion Fee' },
    { key: 'international_fee', name: 'International Transaction Fee' },
    { key: 'payout_fee', name: 'Payout Fee' },
] as const;

export const PAID_STATUSES = ['CREATOR_FULFILLED', 'PAID_NOT_FULFILLED', 'REFUNDED', 'DISPUTED'] as const;

export const MAX_ORDERS_PER_PAGE = 1000;
